document.addEventListener('DOMContentLoaded', () => {

  const mainButton = document.querySelector('[id^="ProductSubmitButton"]');
  const stickyBar = document.querySelector('.sticky-atc');
  const stickyButton = document.querySelector('[data-sticky-atc]');

  if (!mainButton || !stickyBar || !stickyButton) return;

  let mainButtonVisible = true;
  let footerVisible = false;

  const updateBar = () => {
    stickyBar.classList.toggle('show', !mainButtonVisible && !footerVisible);
  };

  const buttonObserver = new IntersectionObserver(
    ([entry]) => {
      mainButtonVisible = entry.isIntersecting;
      updateBar();
    },
    { threshold: 0 }
  );

  const footerObserver = new IntersectionObserver(
    ([entry]) => {
      footerVisible = entry.isIntersecting;
      updateBar();
    },
    { threshold: 0 }
  );

  buttonObserver.observe(mainButton);

  const footer = document.querySelector('.footer-block--newsletter');
  if (footer) footerObserver.observe(footer);

  stickyButton.addEventListener('click', () => {
    mainButton.click();
  });

});